import { VisibilityOffSharp, VisibilitySharp } from '@mui/icons-material';
import { TextField } from '@mui/material';
import { H3 } from 'app/components/Typography';
import { useState } from 'react';

export const OpenAIForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');
  return (
    <>
      <H3 style={{ minWidth: '500px' }}>Key Name</H3>

      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="Name of the Key"
          value={values.name}
          onChange={(e) => setValues({ ...values, name: e.target.value })}
        ></TextField>
      </center>
      <br></br>
      <center>
        <TextField
          fullWidth
          autoFocus
          type={passwordType}
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          variant="outlined"
          label="API Key"
          placeholder="sk-xxxxxxxxxxxxxxxxxxxxxxxx"
          value={values.key}
          onChange={(e) => setValues({ ...values, key: e.target.value })}
        ></TextField>
      </center>
    </>
  );
};
